interface BrowserInfo {
  name: string;
  version: number;
}

export const getBrowserInfo = (): BrowserInfo => {
  const userAgent = navigator.userAgent;
  let name = "";
  let version = 0;

  // Check Chrome
  if (userAgent.includes("Chrome") && !userAgent.includes("Edg")) {
    name = "Chrome";
    const versionMatch = userAgent.match(/Chrome\/(\d+)/);
    version = versionMatch ? parseInt(versionMatch[1]) : 0;
  }
  // Check Edge
  else if (userAgent.includes("Edg")) {
    name = "Edge";
    const versionMatch = userAgent.match(/Edg\/(\d+)/);
    version = versionMatch ? parseInt(versionMatch[1]) : 0;
  }
  // Check Safari
  else if (userAgent.includes("Safari") && !userAgent.includes("Chrome")) {
    name = "Safari";
    const versionMatch = userAgent.match(/Version\/(\d+\.\d+)/);
    version = versionMatch ? parseFloat(versionMatch[1]) : 0;
  }
  // Check Firefox
  else if (userAgent.includes("Firefox")) {
    name = "Firefox";
    const versionMatch = userAgent.match(/Firefox\/(\d+)/);
    version = versionMatch ? parseInt(versionMatch[1]) : 0;
  }

  return { name, version };
};

export const isBrowserSupported = (): boolean => {
  const { name, version } = getBrowserInfo();

  switch (name) {
    case "Chrome":
      return version >= 119;
    case "Edge":
      return version >= 119;
    case "Safari":
      return version >= 17.4;
    case "Firefox":
      return version >= 121;
    default:
      return true; // Allow all other browsers so we can verify those later.
  }
}; 